import _ from "lodash";
import dayjs from "dayjs";
import { CourtAppointment } from "../types/CourtAppointment";

export const hasActiveCourtAppointment = (courtAppointments: CourtAppointment[]) => {
  return _.some(courtAppointments, (courtAppointment) => {
    const appointmentDate = dayjs(courtAppointment?.courtDate?.appointmentDate);
    return appointmentDate.isValid() && appointmentDate.isSameOrAfter(new Date(), "day") && courtAppointment.advoAssist;
  });
};

export const hasCourtAppointmentDatePassed = (courtAppointment: CourtAppointment) => {
  const appointmentDate = dayjs(courtAppointment.courtDate?.appointmentDate);
  return appointmentDate.isValid() && dayjs().isAfter(appointmentDate, "day");
};
